import { render } from "./ListTermButton.vue?vue&type=template&id=099339da&scoped=true"
import script from "./ListTermButton.vue?vue&type=script&lang=js"
export * from "./ListTermButton.vue?vue&type=script&lang=js"

import "./ListTermButton.vue?vue&type=style&index=0&id=099339da&scoped=true&lang=stylus"

import exportComponent from "F:\\xampp\\htdocs\\GITLAB\\2025\\tokyo-shoseki\\r9-102025\\08j_j2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099339da"]])

export default __exports__